<template>
<div class="chapter">
<div class="inner_page">
<h1>1</h1>
<blockquote>
<p class="first">…a giggle is a cackle without eggs…</p>
<p style="text-align:right;"><i>Monroe D. Underwood</i></p>
</blockquote>
<p class="sectiontop">I came out of Schweinschwanz’s Super-Discount Drugs at Belmont and Central carrying a busted carton of Camel cigarettes.</p>
<p>There was a sparkling-new bronze Driefach-Shrecken supercharged twelve-cylinder sports coupé parked behind my Olds.</p>
<p>At a forty-five-degree angle.</p>
<p>Its hood was up.</p>
<p>Its radiator steamed.</p>
<p>Its engine smoked.</p>
<p>A redheaded young woman was jumping up and down and shaking her fist at it.</p>
<p>She was saying <i>Deutschland über alles</i> my ass.</p>
<p>Her hot gray eyes caught mine and she lowered her voice.</p>
<p>I’m a lousy lip-reader but most of her barrage didn’t require an expert.</p>
<p>I grinned and climbed into the Olds.</p>
<p>By the time I started the engine the redhead was standing at the door.</p>
<p>She said all right buster what’s so goddam funny?</p>
<p>I shrugged.</p>
<p>I said oh nothing whatsoever.</p>
<p>I said you see sometimes I get these facial spasms.</p>
<p>She said facial spasms my ass.</p>
<p>She said would you be going as far as Kimball?</p>
<p>I nodded.</p>
<p>She reached for the door handle and said okay?</p>
<p>There was a compelling anxiety about her.</p>
<p>I shrugged.</p>
<p>She got in and slammed the door.</p>
<p>She said thanks.</p>
<p>She said I wouldn’t have bothered you if you hadn’t laughed at me.</p>
<p>I said I didn’t laugh at you.</p>
<p>I said I grinned at you.</p>
<p>She said there’s a difference?</p>
<p>I shrugged.</p>
<p>So did she.</p>
<p>She said twenty-two thousand dollars and the goddam thing won’t run.</p>
<p>I said well once in a while you got to get a tune-up.</p>
<p>She said tune-up my ass.</p>
<p>She said not at sixteen hundred miles.</p>
<p>Her voice was like shaggy silk.</p>
<p>If there is such a thing.</p>
<p>She was mid-twenties and slim except for a bosom that dynamited the front of her floppy short-sleeved black sweater.</p>
<p>Her faded blue jeans were intriguingly tight and her beaded white moccasins had broken seams.</p>
<p>She had flaming red hair and a pugnacious nose and six hundred and twenty-five thousand freckles.</p>
<p>Give or take a few.</p>
<p>She had a soft gentle mouth and she wore no rings and her perfume was like distant cinnamon.</p>
<p>She said sorry to lean on you like this but I have a three o’clock appointment.</p>
<p>I said it’s right on my way.</p>
<p>She accepted a cigarette and she held a light for us.</p>
<p>She rode in silence until we reached Pulaski Road.</p>
<p>Then she said recently it’s just been one goddam thing after another.</p>
<p>I shrugged.</p>
<p>I said north or south on Kimball?</p>
<p>She said the hell with it.</p>
<p>She said just drop me at the corner.</p>
<p>She said I’m going to see a private detective.</p>
<p>She said you may not believe this but his office is in a tavern booth.</p>
<p>She giggled.</p>
<p>It was a very nice giggle.</p>
<p>As giggles go.</p>
<p>Which isn’t very far.</p>
<p>She said can you imagine such a thing?</p>
<p>I shrugged.</p>
<p>I said there’s really nothing wrong with consulting a private detective.</p>
<p>She said not that.</p>
<p>She said I mean the part about him having his office in a tavern booth.</p>
<p>She said that’s crazy.</p>
<p>I shrugged.</p>
<p>I said well you got to admit it’s better than an outhouse.</p>
<p>She squinted at me.</p>
<p>She said I think I’ll get out right here.</p>
<p>I said why?</p>
<p>She said there’s something peculiar about your logic.</p>
<p>I beat the next traffic light and kept moving.</p>
<p>I said are you talking about Wallace’s Tavern?</p>
<p>She said yes do you know him?</p>
<p>I said Wallace?</p>
<p>She said no this detective.</p>
<p>She said Chance Purdue.</p>
<p>I said Chance Purdue is undoubtedly the best in the business.</p>
<p>I said he’s far ahead of his time and he has the courage of fifty lions.</p>
<p>She smiled an even-toothed white smile.</p>
<p>She said come on now do you really know Chance Purdue?</p>
<p>I said sure.</p>
<p>We had reached Belmont and Kimball.</p>
<p>I squeaked the Olds into Wallace’s tiny parking lot.</p>
<p>I said Purdue won’t be in his office so I’ll buy you a drink.</p>
<p>She gave me a sidelong gray glance.</p>
<p>She said how do you know he won’t be in?</p>
<p>I said well in the first place you’re fifteen minutes early and in the second place I’m Chance Purdue.</p>
<p>She thought it over.</p>
<p>Then she put her hands to her face and laughed.</p>
<p>I liked her laugh better than her giggle.</p>
<p>Not that I have anything against giggles.</p>
<p>It’s just that I can do without them.</p>
<p>She said my sincere apologies Mr. Purdue.</p>
<p>She said I’m Spice Dugan.</p>
<p>She put out a freckled hand.</p>
<p>I took it.</p>
<p>I said I gathered as much.</p>
<p>I said what’s on your mind?</p>
<p>Spice Dugan said I want to talk to you about my father.</p>
<p>She said I’ll explain in your office.</p>
<p>We got out of the Olds and a big man in a plaid sports coat left a black Ford sedan that was parked in a corner of the lot.</p>
<p>He moved very rapidly to Wallace’s rear entrance.</p>
<p>He blocked the door.</p>
<p>He said are you Chance Purdue?</p>
<p>I shrugged.</p>
<p>I said well that would depend on just what you want with Chance Purdue.</p>
<p>The big man said Purdue I’m gonna give it to you right here.</p>
<p>I shrugged.</p>
<p>The big man’s hand darted into his plaid sports coat.</p>
<p>I stepped right into him.</p>
<p>I hit him very hard in the solar plexus.</p>
<p>He crumpled over.</p>
<p>I straightened him with a left uppercut.</p>
<p>I drove him into a stack of Old Washensachs Beer cases with a long overhand right.</p>
<p>Spice Dugan’s jaw was sagging.</p>
<p>She stared at me like I had just crawled out of a black lagoon.</p>
<p>She said my God why did you do that?</p>
<p>I shrugged.</p>
<p>I said he was going for his gun.</p>
<p>Spice said gun my ass.</p>
<p>She said all he had was a white envelope.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Ch01.vue?198baccb